import * as types from "./types";
import { LOGOUT } from "../iam/types";
/*
conversations -> list of conversations
messages: {
    {'convesation_guid': {
        'is_loading'
        'errors'
        'list':[]
        'last_evaluated_key'        
    }}
}
*/

export const defaultState = {
  conversations: [],
  loading_conversations: false,
  conversations_errors: [],
  messages: {},
  messages_pagination: {},
  loading_messages: {},
  messages_errors: {},
  conversation_members: [], //THis will hold all the users that a user could communicate to by sending a new message
  loading_conversation_members: false
};

const messaging = (state = defaultState, action) => {
  switch (action.type) {
    case LOGOUT:
      return defaultState;
    case types.FETCHING_CONVERSATIONS:
      return {
        ...state,
        loading_conversations: action.loading
      };
    case types.FETCHED_CONVERSATIONS:
      return {
        ...state,
        conversations: action.conversations,
        loading_conversations: action.loading
      };
    case types.ERROR_FETCHING_CONVERSATIONS:
      return {
        ...state,
        conversations_errors: [...state.conversations_errors, action.error],
        messages_errors: { ...state.messages_errors, [action.conversation_guid]: action.error },
        loading_messages: { ...state.loading_messages, [action.conversation_guid]: false },
        loading: action.loading
      };
    case types.FETCHING_MESSAGES:
      return {
        ...state,
        loading_messages: { ...state.loading_messages, [action.conversation_guid]: true }
      };
    case types.FETCHED_MESSAGES:
      return {
        ...state,
        messages: { ...state.messages, [action.conversation_guid]: action.messages },
        messages_pagination: {
          ...state.messages_pagination,
          [action.conversation_guid]: { has_more: action.has_more, last_evaluated_key: action.last_evaluated_key }
        },
        loading_messages: { ...state.loading_messages, [action.conversation_guid]: false }
      };
    case types.FETCHING_CONVERSATION_MEMBERS:
      return {
        ...state,
        loading_conversation_members: action.loading
      };
    case types.FETCHED_CONVERSATION_MEMBERS:
      return {
        ...state,
        loading_conversation_members: action.loading,
        conversation_members: action.conversation_members
      };
    case types.ERROR_FETCHING_CONVERSATION_MEMBERS:
      return {
        ...state,
        loading_conversation_members: action.loading
      };
    default:
      return state;
  }
};
export default messaging;
